import { CcfBox, CcfOverflowIcon, CcfTypography } from '@nice-ccf/ui-controls';
import { useEffect } from 'react';
import { Contact } from '../../model/contact';
import styles from './contact-control-panel-sub-heading.module.scss';
import { Divider } from '@mui/material';

/* eslint-disable-next-line */
export interface ContactControlPanelSubHeadingProps {
  subHeading1?: string;
  subHeading2?: string;
  subHeading3?: string;
  contact: Contact;
}

/**
 * Component display sub heading for contact control panel
 * @param props -ContactControlPanelSubHeadingProps
 * ```
 * @example -
 * const subHeading1 = "253-895-8956"
 * const subHeading2 = "#439-Z3FM-5S23"
 * const subHeading3 = "Cust. Service Request"
 * <ContactControlPanelSubHeading subHeading1={props.subHeading1} subHeading2={props.subHeading2} subHeading3={props.contact.queueName} />
 * ```
 */
export function ContactControlPanelSubHeading(
  props: ContactControlPanelSubHeadingProps
) {
  let subheading2Arrtext: any = [];
  if (props.subHeading2) {
    subheading2Arrtext = props.subHeading2?.split('+');
  }
  // useEffect(() => {
  //   if(props.subHeading2) {
  //     subheading2Arrtext =  props.subHeading2?.split('+');
  //   }
  // },[]);

  return (
    <CcfBox className={styles.subHeading}>
      {/* <CcfTypography variant="inherit" className="subHeading1">
        {props.subHeading1}
      </CcfTypography> */}

      <section className="subHeading2">
        <CcfTypography variant="inherit" className="subHeading2LeftText">
          {subheading2Arrtext.length > 0 ? subheading2Arrtext[0] : ''}{' '}
        </CcfTypography>{' '}
        <CcfTypography variant="inherit" className="subHeading2RightText">
          {subheading2Arrtext.length > 1 ? subheading2Arrtext[1] : ''}{' '}
        </CcfTypography>
        {subheading2Arrtext.length > 2 && <CcfOverflowIcon />}
      </section>
      {subheading2Arrtext.length > 2 && (
        <Divider
          variant="fullWidth"
          className="horizontalDivider"
          style={{ marginTop: '5px' }}
        />
      )}

      <CcfTypography variant="inherit" className="subHeading3">
        {' '}
        {props.subHeading3}
      </CcfTypography>
    </CcfBox>
  );
}

export default ContactControlPanelSubHeading;
